<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">	
			<top-nevleft></top-nevleft>
			
		 <b-col class="p-0">
		 <b-row class="breadcrumbrow mt-1 m-0">				
			<b-col>
			 <h5 class="text-center">Admin Dashboard</h5>
			</b-col>				
		 </b-row>
		 
		<b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6">
					<!--<h3 class="text-left">Manage Category</h3> -->
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					<b-button variant="dark" pill class="mr-2" @click="showAddModal()">Add Category</b-button>
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
						<b-row class="mt-4 px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="4" offset-md="2">
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined class="text-left" id="my-table" stacked="md" :items="filteredCategory" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
									<template v-slot:cell(status)="row">
										<b-badge pill variant="danger" v-if="row.value == 0">INACTIVE</b-badge>
										<b-badge pill variant="success" v-else>ACTIVE</b-badge>
									</template>
									<template v-slot:cell(html)="row">
										<span v-html="row.value"></span>
									</template>
									<template v-slot:cell(actions)="row">
										<b-button pill variant="outline-primary" class="mr-1 icon-btn" @click="showUpdateModal(row.item, row.index, $event.target)" size="sm"><b-icon icon="pencil" scale="1.3" ></b-icon></b-button>
										<b-button pill variant="outline-danger" class="mr-1 icon-btn" @click="showDeleteModal(row.item)" size="sm"><b-icon icon="trash" scale="1.3" ></b-icon></b-button>
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Showing 1 to 5 of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>

			
			<b-modal id="my-modal" :title="(selectedItem.id > 0)?'Edit Category':'Add Category'" size="lg" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
				<form ref="form" @submit.stop.prevent="modalSubmit">
					<b-container fluid>
						<b-row class="mb-0">
							<b-col cols="12">
								<b-row class="mb-3">
									<b-col cols="3" class="text-right"><label class="font-sm">Title</label></b-col>
									<b-col><b-form-input ref="title1" autofocus v-model="selectedItem.title" size="sm" @change="updateUniqCode()"></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="3" class="text-right"><label class="font-sm">URL Slug</label></b-col>
									<b-col><b-form-input v-model="selectedItem.url_slug" size="sm"></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="3" class="text-right"><label class="font-sm">Unique code</label></b-col>
									<b-col cols="4">
										<b-form-select v-model="selectedItem.parent" :options="filteredCategory" size="sm" required></b-form-select>
									</b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="3" class="text-right"><label class="font-sm">Category Type</label></b-col>
									<b-col cols="4">
										<b-form-select v-model="selectedItem.category_type" size="sm" required>
											<b-form-select-option value="PRODUCT">Products</b-form-select-option>
											<b-form-select-option value="PAGE">Page</b-form-select-option>
										</b-form-select>
									</b-col>
								</b-row>
								<b-row class="mb-3" v-if="selectedItem.category_type == 'PAGE'">
									<b-col cols="3" class="text-right"><label class="font-sm">Linked Page</label></b-col>
									<b-col cols="9">
										<b-form-select v-model="selectedItem.page_link" size="sm" required>
											<b-form-select-option v-for="item in pages" :key="item.id" :value="item.id">{{item.title}}</b-form-select-option>
										</b-form-select>
									</b-col>
								</b-row>
							</b-col>
						</b-row>
						<b-row class="mb-3 pt-3" style="background-color: #f7f7f7">
							<b-col cols="12">
								<b-row class="mb-3">
									<b-col cols="3" class="text-right"><label class="font-sm">Page Title</label></b-col>
									<b-col cols="9"><b-form-input v-model="selectedItem.page_title" size="sm"></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="3" class="text-right"><label class="font-sm">Meta Keywords</label></b-col>
									<b-col cols="9"><b-form-input v-model="selectedItem.meta_keywords" size="sm"></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="3" class="text-right"><label class="font-sm">Meta Description</label></b-col>
									<b-col cols="9"><b-form-textarea v-model="selectedItem.meta_description" size="sm" :maxlength="250" rows="3"></b-form-textarea></b-col>
								</b-row>
							</b-col>
						</b-row>
						<b-row class="mb-1">
							<b-col cols="12">
								<b-row class="mb-3">
									<b-col cols="3" class="text-right"><label class="font-sm">Position</label></b-col>
									<b-col cols="4"><b-form-input v-model="selectedItem.position" size="sm"></b-form-input></b-col>
								</b-row>
								<b-row class="mb-3">
									<b-col cols="3" class="text-right"><label class="font-sm">Status</label></b-col>
									<b-col cols="4"><b-form-select v-model="selectedItem.status" :options="$root.status_options" size="sm" required></b-form-select></b-col>
								</b-row>
							</b-col>
							<b-button type="submit" size="sm" style="display:none;">SUBMIT HANDLER</b-button>
						</b-row>
					</b-container>
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
		
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
		<top-footer></top-footer>
	</b-col>
	</b-row>		
	</b-container>
	</div>
	
</template>
<script>
//import Header from "@/components/admin/Header.vue";
import Header from "@/components/header.vue";
import Footer from "@/components/footer-admin.vue";
import TreeviewPage from "@/components/admin/nevleft.vue";
export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"top-footer": Footer,
		"top-nevleft": TreeviewPage,
	},
	mounted(){
		var self = this;
		Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
	},
	data() {
		//var self = this;
		return{
			loading: true, 
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Category',
					active: true
				}
			],
			recordUrl: this.$root.WEBAPI+'secureapi/product/category-record',
			insertUrl: this.$root.WEBAPI+'secureapi/product/category-insert',
			updateUrl: this.$root.WEBAPI+'secureapi/product/category-update',
			deleteUrl: this.$root.WEBAPI+'secureapi/product/category-delete',
			/*filtercategory: [{ text: 'Root', value: '0' }],*/
			filteredCategory: [],
			records: [],
			statusOptions: [{ value: 0, text: 'Disabled' },{ value: 1, text: 'Enabled' }],
			pages: [],
			fields: [
				{ key: 'id', label: 'ID'},
				{ key: 'html', label: 'Title'},
				{ key: 'url_slug', label: 'URL Slug'},
                { key: 'position', label: 'Position'},
				{ key: 'status', label: 'Status' },
				{ key: 'actions', label: 'Actions', 'extra': 1, class:'text-right' }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {
				category_type: 'PRODUCT'
			},
			emptyItem: {
				id: 0,
				title: '',
				url_slug: '',
				category_type: 'PRODUCT',
				parent: 0,
				position: 0,
				status: 1
			}
		};
	},
	methods: {
		filterCategory(items){
			//var self = this;
			return items.filter(function (item) {
				if(item.parent ==0){
					return true;
				}
			})
		},
		filterChildCategory(id, index){
			var self = this;
			var tab = '';
			for (let i = 0; i < index; i++) {
				tab += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
			}
			this.records.forEach(function(field){
				if(field.parent == id){
					var tmp = Object.assign({}, field);
					tmp.html = tab+field.title;
					tmp.index = index;
					tmp.value = field.id;
					self.filteredCategory.push(tmp);
					
					self.filterChildCategory(field.id, index+1);
				}
			});
			return ;
		},
		redirectUrl(url){
			this.$router.push(url);
		},
		updateUniqCode(){
			this.selectedItem.url_slug = this.selectedItem.title.replace(/\s+/g, '-').toLowerCase().trim();
		},
		showAddModal(){
			this.selectedItem = Object.assign({}, this.emptyItem);
			console.log(JSON.stringify(this.selectedItem));
			
			this.$root.$emit('bv::show::modal', 'my-modal');
			
		},
		showUpdateModal(item, index, button) {
			this.selectedItem = Object.assign({}, item);
			console.log(JSON.stringify(this.selectedItem));

			this.$root.$emit('bv::show::modal', 'my-modal', button)
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete Color.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						delete_id: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = "";
			if(self.selectedItem.id == 0){
				submitUrl = self.insertUrl;
			}else{
				submitUrl = self.updateUrl;
			}


			self.axios.post(submitUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.selectedItem
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('my-modal');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		
		

		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					//var filteredarr = self.filtercategory(response.data.result);

					self.records = response.data.result.category;
					self.pages = response.data.result.pages;
					self.loading = false;
					self.totalRows = self.records.length;

					self.filteredCategory = [];
					self.filterChildCategory(0, 0);
					
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		}
	}
}
</script>
